import { EntityActionTypeSelectOptionValue } from '../Entity'

export const REQUEST_ACTION_ARCHIVE_ITEM = 'archive_item'

export const REQUEST_ACTION_RESTORE_ITEM = 'restore_item'

export const REQUEST_ACTION_RESTORE_MASS = 'restore_mass'

export const REQUEST_ACTION_ARCHIVE_MASS = 'archive_mass'

export const REQUEST_ACTION_MARK_AS_READ = 'mark_as_read_item'

export const REQUEST_ACTION_MARK_AS_READ_MASS = 'mark_as_read_mass'

export const REQUEST_ACTION_MARK_AS_UNREAD = 'mark_as_unread_item'

export const REQUEST_ACTION_MARK_AS_UNREAD_MASS = 'mark_as_unread_mass'

export const REQUEST_ACTION_UPDATE_STATUS_ITEM = 'update_status_item'

export const REQUEST_ACTION_UPDATE_STATUS_MASS = 'update_status_mass'

export const REQUEST_ACTION_EDIT_CATEGORY_ITEM = 'edit_category_item'

export const REQUEST_ACTION_EDIT_CATEGORY_MASS = 'edit_category_mass'

export const REQUEST_ACTION_EDIT_LABEL_ITEM = 'edit_label_item'

export const REQUEST_ACTION_EDIT_LABEL_MASS = 'edit_label_mass'

export const REQUEST_ACTION_EDIT_PROVIDER_ITEM = 'edit_provider_item'

export const REQUEST_ACTION_EDIT_PROVIDER_MASS = 'edit_provider_mass'

export const REQUEST_ACTION_ASSIGN_ITEM = 'assign_item'

export const REQUEST_ACTION_ASSIGN_MASS = 'assign_mass'

export const REQUEST_ACTION_DUE_DATE_ITEM = 'update_due_date_item'

export const REQUEST_ACTION_DUE_DATE_MASS = 'update_due_date_mass'

export const REQUEST_ACTION_MARK_AS_PUBLIC_MASS = 'mark_as_public_mass'

export const REQUEST_ACTION_MARK_AS_PUBLIC = 'mark_as_public'

export const REQUEST_ACTION_MARK_AS_PRIVATE_MASS = 'mark_as_private_mass'

export const REQUEST_ACTION_MARK_AS_PRIVATE = 'mark_as_private'

export const REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM =
  'add_connected_requests'

export const REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS =
  'add_connected_requests_mass'

export const REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS = 'group_requests'

export const REQUEST_ACTION_CONNECT_DOC_FLOW_ITEM = 'connect_document_staplings'

export const REQUEST_ACTION_CONNECT_DOC_FLOW_MASS =
  'connect_document_staplings_mass'

export const REQUEST_ACTION_CREATE_DOC_FLOW_ITEM = 'create_document_stapling'

export const REQUEST_ACTION_CREATE_DOC_FLOW_MASS =
  'create_document_stapling_mass'

export const REQUEST_MASS_ACTION_NAMES = {
  [REQUEST_ACTION_ARCHIVE_ITEM]: 'archive',
  [REQUEST_ACTION_ARCHIVE_MASS]: 'archive',
  [REQUEST_ACTION_ASSIGN_ITEM]: 'update_assignee',
  [REQUEST_ACTION_ASSIGN_MASS]: 'update_assignee',
  [REQUEST_ACTION_CONNECT_DOC_FLOW_MASS]: 'connect_document_staplings',
  [REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM]: 'add_connected_requests',
  [REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS]: 'add_connected_requests',
  [REQUEST_ACTION_DUE_DATE_ITEM]: 'update_due_date',
  [REQUEST_ACTION_DUE_DATE_MASS]: 'update_due_date',
  [REQUEST_ACTION_EDIT_CATEGORY_ITEM]: 'update_category',
  [REQUEST_ACTION_EDIT_CATEGORY_MASS]: 'update_category',
  [REQUEST_ACTION_EDIT_LABEL_ITEM]: 'update_labels',
  [REQUEST_ACTION_EDIT_LABEL_MASS]: 'update_labels',
  [REQUEST_ACTION_EDIT_PROVIDER_ITEM]: 'update_contractors',
  [REQUEST_ACTION_EDIT_PROVIDER_MASS]: 'update_contractors',
  [REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS]: 'group_requests',
  [REQUEST_ACTION_MARK_AS_PRIVATE]: 'hide_for_dwellers',
  [REQUEST_ACTION_MARK_AS_PRIVATE_MASS]: 'hide_for_dwellers',
  [REQUEST_ACTION_MARK_AS_PUBLIC]: 'show_for_dwellers',
  [REQUEST_ACTION_MARK_AS_PUBLIC_MASS]: 'show_for_dwellers',
  [REQUEST_ACTION_MARK_AS_READ]: 'mark_as_read',
  [REQUEST_ACTION_MARK_AS_READ_MASS]: 'mark_as_read',
  [REQUEST_ACTION_MARK_AS_UNREAD]: 'mark_as_unread',
  [REQUEST_ACTION_MARK_AS_UNREAD_MASS]: 'mark_as_unread',
  [REQUEST_ACTION_RESTORE_ITEM]: 'restore',
  [REQUEST_ACTION_RESTORE_MASS]: 'restore',
  [REQUEST_ACTION_UPDATE_STATUS_ITEM]: 'update_status',
  [REQUEST_ACTION_UPDATE_STATUS_MASS]: 'update_status',
}

export const REQUEST_MASS_ACTION_ID_KEY = 'pk'

export const RequestTableExportOptionValue = {
  ExportEmailsFilesChats: 'exportEmailsFilesChats',
  ExportInvoice: 'exportInvoice',
  ExportTable: 'exportTable',
}

export const REQUEST_ITEM_ACTION_TYPES = [
  EntityActionTypeSelectOptionValue.Edit,
  EntityActionTypeSelectOptionValue.RemoveAll,
]
